export default __webpack_public_path__ + "static/floor1_image3-pc-9b065ff17398fff1c9da4d38d0d2fd55.png";